import React from "react";
import {Container} from "./style";
import {isMobile} from "react-device-detect";

export default props => {
  const ignoreMobile = () => {
    sessionStorage.setItem("ignoreMobileAlert", true);
    window.location.reload();
  };
  if (isMobile && !sessionStorage.getItem("ignoreMobileAlert")) {
    return (
      <Container>
        <div className="alert">
          <p>
            در حال حاضر نسخه وب موبایل تنخواه‌گردان در حال توسعه می‌باشد، برای تجربه
            بهتر، لطفا اپلیکیشن اندروید را دریافت کنید
          </p>
          <div className="buttons">
            <a href="https://tankhahgardan.com/download/">
              <button className="get">دریافت اپلیکیشن</button>
            </a>
            <button onClick={ignoreMobile}>بعدا</button>
          </div>
        </div>
      </Container>
    );
  } else {
    return "";
  }
};
